import { effect, inject, Injectable, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { type RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { TranslocoService } from '@jsverse/transloco';
import { AMP_APP_SHELL_CONFIG } from './provide-app-shell';

/**
 * Route `title` values are message ids, not literal text. The document title is
 * `<route> · <app name>`, or just the app name when the route has no title.
 */
@Injectable()
export class AmpTitleStrategy extends TitleStrategy {
  readonly routeTitleKey = signal<string | undefined>(undefined);
  readonly #title = inject(Title);
  readonly #transloco = inject(TranslocoService);
  readonly #config = inject(AMP_APP_SHELL_CONFIG);

  constructor() {
    super();

    effect(() => {
      const lang = this.#transloco.activeLang();
      const appName = this.#transloco.translate(this.#config.appNameKey, {}, lang);
      const routeKey = this.routeTitleKey();

      this.#title.setTitle(
        routeKey ? `${this.#transloco.translate(routeKey, {}, lang)} · ${appName}` : appName,
      );
    });
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.routeTitleKey.set(this.buildTitle(snapshot));
  }
}
